const VideoRecording = class VideoRecording {
  constructor(video, width, height, callback) {
    const constraints = {
      audio: true,
      video: {
        width,
        height,
        advanced: [
          {
            aspectRatio: 1.33333333333,
          },
          {
            aspectRatio: 1,
          },
          {
            echoCancellation: {
              exact: true,
            },
          },
          {
            googEchoCancellation: {
              exact: true,
            },
          },
          {
            googExperimentalEchoCancellation: {
              exact: true,
            },
          },
          {
            googNoiseSuppression: {
              exact: true,
            },
          },
          {
            googExperimentalNoiseSuppression: {
              exact: true,
            },
          },
          {
            googAutoGainControl: {
              exact: true,
            },
          },
          {
            googExperimentalAutoGainControl: {
              exact: true,
            },
          },
          {
            googHighpassFilter: {
              exact: true,
            },
          },
          {
            googTypingNoiseDetection: {
              exact: true,
            },
          },
          {
            googAudioMirroring: {
              exact: false,
            },
          },
          {
            deviceId: {
              exact: ['default'],
            },
          },
        ],
      },
    }
    this.video = video
    this.width = width
    this.height = height
    this.recorder = null
    this.recordingFile = null
    navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
      this.stream = stream
      this.video.srcObject = stream
      this.recorder = new MediaRecorder(stream, { mimeType: 'video/webm;codecs=vp9' })
      this.recorder.ondataavailable = (e) => {
        this.recordingFile = new Blob([e.data], { type: e.data.type })
      }
      this.video.onloadedmetadata = () => {
        this.video.play()
        if (callback) {
          callback()
        }
      }
    })
  }
  startRecording() {
    if (this.recorder) {
      this.recorder.start()
    }
  }
  stopRecording() {
    if (this.recorder) {
      this.recorder.stop()
    }
  }
  stopVideo() {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => {
        track.stop()
      })
    }
  }
  isStreamActive() {
    if (!this.stream) return false
    if (!this.stream.active) return false
    if (
      !this.stream
        .getTracks()
        .some((t) => t.kind == 'video' && t.enabled == true && t.muted == false)
    )
      return false
    if (
      !this.stream
        .getTracks()
        .some((t) => t.kind == 'audio' && t.enabled == true && t.muted == false)
    )
      return false
    return true
  }
  getVideoStream() {
    return this.video
  }
  getRecordingFile() {
    return this.recordingFile
  }
  getRecordingState() {
    if (this.recorder) {
      return this.recorder.state
    } else {
      return 'nostate'
    }
  }
}

export default VideoRecording



// WEBPACK FOOTER //
// ./src/functions/class/VideoRecording.js